module.exports = __webpack_public_path__ + "static/media/background.9f24aa5e.png";